import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { useNavigate } from 'react-router-dom';
import { signInWithPopup, GoogleAuthProvider, setPersistence, browserLocalPersistence, signInWithPhoneNumber } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import RegisterPopup from '../components/RegisterPopup';


import './LoginPage.css';
import { auth, db } from '../firebase/firebase';

// create RTL Cache
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

// create RTL theme
const theme = createTheme({
    direction: 'rtl',
});

export default function LoginPage() {
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        // const data = new FormData(event.currentTarget);
        setPersistence(auth, browserLocalPersistence).then(() => {
            const provider = new GoogleAuthProvider();
            signInWithPopup(auth, provider)
                .then((result) => {
                    // The signed-in user info.
                    const user = result.user;
                    const userDocRef = doc(db, 'users', user.uid);
                    getDoc(userDocRef).then(u => {
                        localStorage.setItem('uid', user.uid);
                        if (u.exists() && u.data().isRegistered) {
                            navigate('/');
                            return
                        }
                        navigate('/');
                        const defaultUser = {
                            id: user.uid,
                            title: "",
                            phoneNumber: user.phoneNumber,
                            image: user.photoURL,
                            coverImage: "/images/maya-cover1.jpg",
                            isRegistered: false,
                        }
                        setDoc(userDocRef, defaultUser).then(_ => {
                        })
                    })
                }).catch((error) => {
                    // Handle Errors here.
                    console.error(`failed to login ${error}`);
                });
        });
    };

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <div className="signin-page" dir="rtl">
                    <div className="signin-background">
                        <div className="signin-layout">
                            <Box className="signin-text">
                                <img src="/images/logo-just-YallaGo.png" alt="YallaGo Logo" className="signin-logo" />
                                <h2 className="signin-headline-1">
                                    נמאס לך לטייל לבד?
                                </h2>
                                <h2 className="signin-headline-2">
                                    יאללה, מתחברים!
                                </h2>
                                <p className="intro-body-1">
                                    אתם סטודנטים שאוהבים לטייל, להכיר אנשים חדשים ולגלות את ישראל מזווית קצת אחרת? הגעתם
                                    למקום הנכון!
                                </p>
                                <p className="intro-body-2">
                                    YallaGo הוא אתר שמחבר בין סטודנטים ישראלים שאוהבים לטייל – בדרך קלילה, חברתית
                                    ומותאמת בדיוק למה שאתם מחפשים.
                                </p>
                                <p className="intro-body-3">
                                    כאן תוכלו למצוא את הפרטנר המושלם לטיול המושלם!
                                </p>
                                <p className="intro-body-4">
                                    אז למה אתם מחכים?
                                </p>
                            </Box>
                            <div className="signin-panel" dir="rtl">
                                <Container component="main" maxWidth="xs">
                                    <Box className="signin-box">
                                        <Typography component="h1" variant="h5" className="signin-title">
                                            התחברות / הרשמה
                                        </Typography>

                                        <Box component="form" onSubmit={handleSubmit} noValidate
                                            className="signin-form">
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                className="signIn-button"
                                            >
                                                <img src="/images/google-icon.png" alt="Google" style={{ width: 24, height: 24 }} />
                                                כניסה באמצעות Google
                                            </Button>
                                            <Typography
                                                variant="body2"
                                                sx={{ mt: 2, textAlign: 'center', color: 'gray', fontStyle: 'italic' }}
                                            >
                                                ההתחברות באמצעות מייל אוניברסיטאי בלבד
                                            </Typography>

                                        </Box>
                                    </Box>
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </CacheProvider>

    );
}
